import { NavLink, useLocation } from 'react-router-dom';
import { useApi } from '../../hooks/useApi.js';
import pldLogo from '../../assets/pld-logo.png';

// ── Icons (inline SVG, minimal) ───────────────────────────────────────────────
const Icon = ({ d, size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d={d} />
  </svg>
);

const ICONS = {
  dashboard:  'M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z M9 22V12h6v10',
  production: 'M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.77 3.77z',
  stock:      'M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z M7 7h.01',
  clients:    'M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2 M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z M23 21v-2a4 4 0 0 0-3-3.87 M16 3.13a4 4 0 0 1 0 7.75',
  ownbrand:   'M12 2L2 7l10 5 10-5-10-5z M2 17l10 5 10-5 M2 12l10 5 10-5',
  orders:     'M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2M9 5a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2M12 12h.01M12 16h.01',
  fulfilment: 'M16.5 9.4l-9-5.19 M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z M3.27 6.96L12 12.01l8.73-5.05 M12 22.08V12',
  quotes:     'M9 14l6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2z',
  recipes:    'M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2M9 5a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2m-3 7h.01M12 16h.01M8 12h.01M8 16h.01',
  recipedev:  'M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 1 1 7.072 0l-.548.547A3.374 3.374 0 0 0 14 18.469V19a2 2 0 1 1-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z',
  specs:      'M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2M9 5a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2m-6 9l2 2 4-4',
  outlets:    'M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z',
  hmrc:       'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z M14 2v6h6 M16 13H8 M16 17H8 M10 9H8',
  casks:      'M3 6l9-4 9 4v6c0 5-4 9-9 10-5-1-9-5-9-10V6z M12 8v4 M12 16h.01',
  storage:    'M5 4h14a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z M3 14h18 M3 14v4a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-4',
  warehouse:  'M3 21h18 M5 21V7l7-4 7 4v14 M9 21v-6h6v6 M9 11h.01 M15 11h.01',
  stocktake:  'M9 11l3 3L22 4 M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11',
  billing:    'M9 20h8M7 15h9M10 15V9a3 3 0 1 1 6 0',
  salsa:      'M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0 1 12 2.944a11.955 11.955 0 0 1-8.618 3.04A12.02 12.02 0 0 0 3 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z',
  reports:    'M18 20V10 M12 20V4 M6 20v-6',
  calculator: 'M6 2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z M8 6h8v4H8z M8 14h.01 M12 14h.01 M16 14h.01 M8 18h.01 M12 18h.01 M16 18h.01',
  tasks:      'M9 11l3 3L22 4 M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11',
  schedule:   'M8 2v4 M16 2v4 M3 10h18 M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z',
  help:       'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3 M12 17h.01',
  settings:   'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z',
};

const NAV = [
  {
    group: 'Operations',
    items: [
      { label: 'Dashboard',   path: '/',            icon: 'dashboard',   end: true },
      { label: 'Production',  path: '/production',  icon: 'production' },
      { label: 'Recipes',       path: '/recipes',         icon: 'recipes' },
      { label: 'Stock',       path: '/stock',       icon: 'stock' },
      { label: 'Casks',         path: '/casks',         icon: 'casks' },
      { label: 'Storage Units', path: '/storage-units', icon: 'storage' },
      { label: 'Warehouse Map', path: '/warehouse',      icon: 'warehouse' },
      { label: 'Stock Take',    path: '/stock-take',     icon: 'stocktake' },
      { label: 'Staff Tasks',   path: '/staff-tasks',    icon: 'tasks' },
      { label: 'Production Schedule', path: '/production-schedule', icon: 'schedule' },
      { label: 'Calculators',   path: '/calculators',    icon: 'calculator' },
    ],
  },
  {
    group: 'Commercial',
    items: [
      { label: 'Contract Clients', path: '/clients',     icon: 'clients' },
      { label: 'Own Brand',     path: '/own-brand',     icon: 'ownbrand' },
      { label: 'Orders',        path: '/orders',        icon: 'fulfilment' },
      { label: 'Quotes',        path: '/quotes',         icon: 'quotes' },
      { label: 'Recipe Development', path: '/recipe-dev',     icon: 'recipedev' },
      { label: 'Billing',       path: '/billing',        icon: 'billing' },
      { label: 'Product Specs', path: '/product-specs', icon: 'specs' },
      { label: 'Outlets',       path: '/outlets',       icon: 'outlets' },
    ],
  },
  {
    group: 'Compliance',
    items: [
      { label: 'HMRC',       path: '/hmrc',       icon: 'hmrc' },
      { label: 'SALSA',      path: '/salsa',      icon: 'salsa' },
      { label: 'Reports',    path: '/reports',    icon: 'reports' },
    ],
  },
  {
    group: 'System',
    items: [
      { label: 'Help',       path: '/help',       icon: 'help' },
      { label: 'Settings',   path: '/settings',   icon: 'settings' },
    ],
  },
];

// The permission each page needs (Settings → Permissions). Pages not listed
// (Dashboard, Calculators) are for everyone.
const PAGE_KEY = {
  '/production': 'production', '/recipes': 'recipes', '/stock': 'stock', '/casks': 'casks',
  '/storage-units': 'storage_units', '/warehouse': 'warehouse', '/stock-take': 'stock_take',
  '/staff-tasks': 'staff_tasks', '/production-schedule': 'production_schedule',
  '/clients': 'clients', '/own-brand': 'own_brand', '/orders': 'orders', '/quotes': 'quoting',
  '/recipe-dev': 'recipe_development', '/billing': 'billing', '/product-specs': 'product_specs',
  '/outlets': 'outlets', '/hmrc': 'hmrc', '/salsa': 'salsa', '/reports': 'reports', '/settings': 'admin',
};

export default function Sidebar({ collapsed }) {
  const location = useLocation();
  // Hide pages someone has no access to (None). Until we know, show everything.
  const { data: meData } = useApi('/settings/me');
  const me = meData?.data ?? meData ?? null;
  const canSee = (path) => {
    const key = PAGE_KEY[path];
    if (!key || !me || me.is_system_owner || !me.permissions) return true;
    const lvl = me.permissions[key]?.access_level;
    return lvl === 'read' || lvl === 'write';
  };
  const nav = NAV.map(g => ({ ...g, items: g.items.filter(i => canSee(i.path)) })).filter(g => g.items.length);

  return (
    <aside className="sidebar" style={{ width: collapsed ? 56 : 'var(--sidebar-width)' }}>
      {/* Logo */}
      <div className="sidebar-logo">
        <img src={pldLogo} alt="Pleasant Land Distillery" className="sidebar-logo-mark" />
        {!collapsed && (
          <div className="sidebar-logo-text">
            <span className="sidebar-logo-name">Blake</span>
            <span className="sidebar-logo-sub">Pleasant Land Distillery</span>
          </div>
        )}
      </div>

      {/* Nav groups */}
      <nav className="sidebar-nav">
        {nav.map(({ group, items }) => (
          <div key={group} className="sidebar-group">
            {!collapsed && <div className="sidebar-group-label">{group}</div>}
            {items.map(({ label, path, icon, end }) => (
              <NavLink
                key={path}
                to={path}
                end={end}
                className={({ isActive }) =>
                  `sidebar-link${isActive ? ' sidebar-link--active' : ''}`
                }
                title={label}
              >
                <span className="sidebar-link-icon">
                  <Icon d={ICONS[icon]} size={18} />
                </span>
                {!collapsed && <span className="sidebar-link-label">{label}</span>}
              </NavLink>
            ))}
          </div>
        ))}
      </nav>

      <style>{`
        .sidebar {
          position: fixed;
          left: 0; top: 0; bottom: 0;
          background: var(--pld-green);
          display: flex;
          flex-direction: column;
          z-index: 100;
          transition: width var(--transition);
          overflow: hidden;
          user-select: none;
        }

        .sidebar-logo {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 16px 14px;
          border-bottom: 1px solid var(--pld-green-border);
          min-height: var(--header-height);
          flex-shrink: 0;
        }

        .sidebar-logo-mark {
          width: 32px;
          height: 32px;
          object-fit: contain;
          border-radius: 50%;
          background: #fff;
          flex-shrink: 0;
        }

        .sidebar-logo-text {
          display: flex;
          flex-direction: column;
          line-height: 1.2;
          overflow: hidden;
        }

        .sidebar-logo-name {
          color: #fff;
          font-size: 13px;
          font-weight: 700;
          white-space: nowrap;
        }

        .sidebar-logo-sub {
          color: rgba(255,255,255,0.55);
          font-size: 11px;
          white-space: nowrap;
        }

        .sidebar-nav {
          flex: 1;
          overflow-y: auto;
          overflow-x: hidden;
          padding: 8px 0;
        }

        .sidebar-group {
          margin-bottom: 4px;
        }

        .sidebar-group-label {
          color: rgba(255,255,255,0.4);
          font-size: 10px;
          font-weight: 700;
          letter-spacing: .08em;
          text-transform: uppercase;
          padding: 10px 16px 4px;
          white-space: nowrap;
        }

        .sidebar-link {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 8px 14px;
          color: rgba(255,255,255,0.75);
          border-radius: var(--radius-sm);
          margin: 1px 8px;
          transition: background var(--transition), color var(--transition);
          white-space: nowrap;
        }

        .sidebar-link:hover {
          background: var(--pld-green-hover);
          color: #fff;
        }

        .sidebar-link--active {
          background: rgba(255,220,6,0.15);
          color: var(--pld-yellow) !important;
        }

        .sidebar-link-icon {
          display: flex;
          align-items: center;
          flex-shrink: 0;
        }

        .sidebar-link-label {
          font-size: 13.5px;
          font-weight: 500;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        /* Below 1024px, AppLayout's CSS hardcodes .app-main's left margin to
           56px (it assumes a permanently-collapsed icon rail rather than
           tracking the JS collapsed state, which only toggles via a header
           button click and defaults to expanded). Force the sidebar itself
           to match that same 56px icon-only width here, regardless of the
           collapsed prop, so the two always agree and content/nav is never
           pushed off-screen or hidden behind an oversized sidebar on tablet
           or phone widths. */
        @media (max-width: 1024px) {
          .sidebar {
            width: 56px !important;
          }
          .sidebar-logo-text,
          .sidebar-group-label,
          .sidebar-link-label {
            display: none;
          }
        }
      `}</style>
    </aside>
  );
}
